import script from "./ListWithTooltips.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListWithTooltips.vue?vue&type=script&lang=ts&setup=true"

import "./ListWithTooltips.vue?vue&type=style&index=0&id=cb2ea8e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb2ea8e0"]])

export default __exports__